import { useEffect, useRef } from "react";

const CHARS = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホBraux206";

export default function MatrixRainBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const context = canvas.getContext("2d");
    const fontSize = 20;
    let animationFrameId = 0;
    let lastDraw = 0;
    let drops = [];

    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      const width = window.innerWidth;
      const height = window.innerHeight;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      const columnCount = Math.floor(width / fontSize);
      drops = Array.from({ length: columnCount }, () => Math.floor(Math.random() * -50));
    };

    const draw = (timestamp) => {
      if (timestamp - lastDraw > 110) {
        const width = window.innerWidth;
        const height = window.innerHeight;
        context.fillStyle = "rgba(0, 0, 0, 0.06)";
        context.fillRect(0, 0, width, height);
        context.font = `${fontSize}px monospace`;
        context.fillStyle = "#26d07c";

        drops.forEach((drop, index) => {
          const character = CHARS[Math.floor(Math.random() * CHARS.length)];
          const x = index * fontSize;
          const y = drop * fontSize;
          context.fillText(character, x, y);
          drops[index] = y > height && Math.random() > 0.975 ? 0 : drop + 1;
        });

        lastDraw = timestamp;
      }

      animationFrameId = window.requestAnimationFrame(draw);
    };

    resize();
    window.addEventListener("resize", resize);
    animationFrameId = window.requestAnimationFrame(draw);

    return () => {
      window.removeEventListener("resize", resize);
      window.cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <>
      <canvas ref={canvasRef} className="matrix-rain-canvas" aria-hidden="true" data-testid="login-matrix-canvas" />
      <div className="login-matrix-overlay" aria-hidden="true" data-testid="login-matrix-overlay" />
      <div className="login-matrix-bottom-fade" aria-hidden="true" />
    </>
  );
}